import { compose } from 'react-apollo';
import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';

import DeliveriesListItem from './DeliveriesListItem.js';

export default compose(
  graphql(gql`
    mutation updateDelivery(
      $id: String!,
      $date: String,
      $address: String,
      $phone: String,
      $comment: String,
      $user_id: String,
      $contractor_id: String,
      $index: String,
      $time: String,
      $complete: String,
      $lead_id: String,
      $type_id: String,
      $status_id: String,
      
    ) {
      updateDelivery(
        delivery: {
          id: $id,
          date: $date,
          comment: $comment,
          address: $address,
          phone: $phone,
          user_id: $user_id,
          contractor_id: $contractor_id,
          index: $index,
          time: $time,
          complete: $complete,
          lead_id: $lead_id,
          type_id: $type_id,
          status_id: $status_id,
        }
      ) {
        id,
        created_at
      }
    }
  `, {
    name:'updateDelivery'
  }),

  graphql(gql`
    mutation removeDelivery(
      $id: String!,
      
    ) {
      removeDelivery(
        delivery: {
          id: $id,
        }
      ) {
        id,
        created_at
      }
    }
  `, {
    name:'removeDelivery'
  }),

)(DeliveriesListItem);